<modal #nGmodal [modalConfig]="modalConfig" class="modal-dialog-centered">
     <div class="d-flex justify-content-end align-items-center row" test>
       <div
         class="input-file d-flex justify-content-between"
         (click)="fileUpload.click()"
       >
   
         <div class="">
           <span class="field-file-name">{{
             fileName || ('importCoordinates.importFile' | translate)
           }}</span>
         </div>
   
         <div><i-bs style="font-weight: bold" name="arrow-up"></i-bs></div>
   
       </div>
       <input
         type="file"
         class="form-control hidden-file-input"
         (change)="handleFileInput($event)"
         #fileUpload
       />
     </div>
   
     <div class="col-12">
       <div class="d-flex justify-content-between align-items-center">
         <div *ngIf="invalidData.length" class="text-danger fw-bold">
           {{ 'importCoordinates.invalidCoordinatesCount' | translate:{ count: invalidData.length } }}
         </div>
       </div>
     </div>
     <div
       *ngIf="
         !loadedDataToDisplay.length &&
         fileName &&
         !isLoadingFileData &&
         !loadedData.length
       "
       class="text-center"
     >
       {{ 'importCoordinates.noDataToImport' | translate }}
     </div>
     <div class="d-flex justify-content-center align-items-center">
        <div
          *ngIf="isLoadingFileData"
          class="spinner-border text-info"
        >
          <span class="sr-only">{{ 'common.loading' | translate }}</span>
        </div>
      </div>
    
     <div *ngIf="loadedDataToDisplay.length" class="d-flex flex-column mt-3">
       <div class="import-table-row import-table-header">
        <ng-container *ngIf="entity =='Secteur'">
          <div class="name-column">{{ 'importCoordinates.columns.sector' | translate }}</div>
        </ng-container>
        <ng-container *ngIf="entity =='Zone_superviseur'">
          <div class="name-column">{{ 'importCoordinates.columns.zoneSupervisor' | translate }}</div>
        </ng-container>
        <ng-container *ngIf="entity =='COUNTRY'">
          <div class="name-column">{{ 'importCoordinates.columns.country' | translate }}</div>
        </ng-container>
        <ng-container *ngIf="entity =='Zone'">
          <div class="name-column">{{ 'importCoordinates.columns.zone' | translate }}</div>
        </ng-container>
        <ng-container *ngIf="entity =='Region'">
          <div class="name-column">{{ 'importCoordinates.columns.region' | translate }}</div>
        </ng-container>
         <div class="pe-4">{{ 'importCoordinates.columns.latitude' | translate }}</div>
         <div class="pe-4">{{ 'importCoordinates.columns.longitude' | translate }}</div>
       </div>
       <div style="max-height: 250px; overflow: auto">
         <ng-template ngFor let-item [ngForOf]="loadedDataToDisplay">
           <div
             class="import-table-row custom-table-row mt-2"
             [ngClass]="{ error: invalidData.includes(item[entity.toLowerCase()]), 'table-danger': !item.isValid }"
           >
             <div class="name-column">{{ item[entity.toLowerCase()]  }}</div>
             <div class="coordinate-column">{{ item.y_coord }}</div>
             <div class="coordinate-column">{{ item.x_coord }}</div>
           </div>
         </ng-template>
       </div>
     </div>
   </modal>
   <modal
     #confirmModal
     [modalConfig]="confirmModalConfig"
     class="modal-dialog-centered"
   >
     <div>
       {{ 'importCoordinates.confirmImportQuestion' | translate }}
     </div>
</modal>
   
